import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Form, Dropdown } from "react-bootstrap";

function OrganizationSelector({
  value = 0,
  onChange,
  groups = [],
  isShowTitle = true,
  preventSubmit = false,
  multiple = false,
  isLoggedInUserSuperAdmin = false,
  forCampaigns = false
}) {
  const holder = useRef();
  const [organizationFilter, setOrganizationFilter] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  // const textValue = () => {
  //   if (value && value.length) {
  //     return `${value.length} organization${value.length === 1 ? "" : "s"} selected`;
  //   }
  //   return "All Organizations";
  // };
  const textValue = () => {
    if (multiple && Array.isArray(value) && value.length) {
      return `${value.length} organization${value.length === 1 ? "" : "s"} selected`;
    }
    if (!multiple && value && groups.length) {
      const selectedOrg = groups.find((g) => g.groupId === value || g.groupId === parseInt(value));
      if (selectedOrg) return selectedOrg.groupName;
    }
    return "All Organizations";
  };

  const onClick = (groupId) => {
    if (onChange) {
      if (multiple) {
        if (groupId === null) {
          onChange([]);
        } else {
          let newValue = Array.isArray(value) ? [...value] : [];
          if (newValue.includes(groupId)) {
            newValue = newValue.filter((id) => id !== groupId);
          } else {
            newValue.push(groupId);
          }
          onChange(newValue);
        }
      } else {
        onChange(groupId);
      }
    }
  };

  const isActive = (id) =>
    (multiple && value.indexOf(id) !== -1) || id === parseInt(value);

  useEffect(() => {
    window.addEventListener("click", ({ target }) => {
      if (holder.current && !holder.current.contains(target)) {
        setIsExpanded(false);
      }
    });
  }, [multiple]);

  return (
    <div className="standard-dropdown">
      {isShowTitle && (
        <div className="standard-dropdown-label">Organization:</div>
      )}
      <Dropdown show={isExpanded} ref={holder}>
        <Dropdown.Toggle onClick={() => setIsExpanded(!isExpanded)}>
          {textValue()}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Form.Group className="custom-dropdown-search">
            <Form.Control
              name="organization-dropdown-search"
              placeholder="Enter organization name"
              onChange={({ target }) => setOrganizationFilter(target.value)}
              value={organizationFilter}
            />
          </Form.Group>
          {isLoggedInUserSuperAdmin || !forCampaigns && (
            <Dropdown.Item
              onClick={() => {
                setOrganizationFilter("");
                onClick(null);
              }}
              as="button"
              type="button"
            >
              All Organizations
            </Dropdown.Item>
          )}
          
          {groups
            .filter(
              (item) =>
                !organizationFilter ||
                item.groupName
                  .trim()
                  .toLowerCase()
                  .includes(organizationFilter.trim().toLowerCase())
            )
            .map((organization) => (
              <Dropdown.Item
                key={organization.groupId}
                onClick={(e) => {
                  onClick(organization.groupId);
                  preventSubmit && e.preventDefault();
                }}
                className={
                  isActive(organization.groupId) ? "is-active-option" : ""
                }
                as="button"
              >
                {multiple && (
                  <input
                    type="checkbox"
                    checked={
                      Array.isArray(value) &&
                      value.includes(organization.groupId)
                    }
                    onChange={() => {}}
                  />
                )}
                {organization.groupName}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

const mapStateToProps = (state) => ({
  groups: state.networks.groupsList,
});

export default connect(mapStateToProps, {})(OrganizationSelector);
